import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { ISubmissionFile } from '@publishing-engine/domain/models';
import { FileListDisplay } from '../FileList/FileListDisplay';

type IProps = {
  value: boolean;
  title?: string;
  subtitle?: string;
  standardReportingGuidelinesDetails: string[] | undefined;
  CONSORTFiles: ISubmissionFile[] | undefined;
  ARRIVEFiles: ISubmissionFile[] | undefined;
  StandardReportingGuidelinesFileDetails: ISubmissionFile[] | undefined;
  StandardReportingGuidelinesText?: string | undefined;
};

export const StandardReportingGuidelinesDisplay: React.FC<IProps> = ({
  value,
  title,
  subtitle,
  standardReportingGuidelinesDetails,
  CONSORTFiles,
  ARRIVEFiles,
  StandardReportingGuidelinesFileDetails,
  StandardReportingGuidelinesText
}) => {
  return (
    <Flex flexDirection={'column'}>
      {title && (
        <Flex flexDirection={'column'}>
          <Flex flexDirection={'row'} gap={2}>
            <Text textStyle="headingItem">{title}</Text>
          </Flex>
        </Flex>
      )}
      {subtitle ? (
        <Text textStyle={'textBody'} mb={3}>
          {subtitle}
        </Text>
      ) : (
        <Text textStyle={'textBody'} mb={3}>
          {value ? 'Yes' : 'No'}
        </Text>
      )}
      {standardReportingGuidelinesDetails &&
        value &&
        standardReportingGuidelinesDetails.map(item => (
          <Flex mt={2} flexDirection={'column'} key={item}>
            <Text textStyle="textBody">{item}</Text>
            {item === 'CONSORT Statement' && CONSORTFiles && (
              <FileListDisplay files={CONSORTFiles} />
            )}
            {item === 'ARRIVE' && ARRIVEFiles && (
              <FileListDisplay files={ARRIVEFiles} />
            )}
          </Flex>
        ))}
      {value && StandardReportingGuidelinesFileDetails && (
        <Flex mt={2} flexDirection={'column'}>
          <FileListDisplay files={StandardReportingGuidelinesFileDetails} />
        </Flex>
      )}
      {value === false && StandardReportingGuidelinesText && (
        <Flex mt={1} flexDirection={'column'}>
          <Text textStyle="textBody">
            {' '}
            <i>Additional Details: </i> {StandardReportingGuidelinesText}
          </Text>
        </Flex>
      )}
    </Flex>
  );
};
